import * as util from "lib/util.js";
import { Router } from "@vaadin/router";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import "./kb-toc.js";
import "./kb-topic.js";
import "./kb-topic-breadcrumbs.js";
import "./kb-topic-prevnext.js";

class KbHelpsetSearch extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.addEventListener(
      "tocItemClicked",
      this._handleTocItemClicked.bind(this)
    );
    this.addEventListener(
      "topicLinkClicked",
      this._handleTocTopicLinkClicked.bind(this)
    );
    if (this.state.item) {
      this.refreshData();
    }
  }

  refreshData() {
    storeInstance.dispatch("getHelpsetTOC", {
      externalId: this.state.item.item.externalId,
      langCode: this.state.langCode,
    });
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.state.item_toc) {
      if (!this.rootnode) {
        this.kbrid = this.kbrid
          ? this.kbrid
          : this._recurseToHREF(this.state.item_toc[0]); //if no kbrid passed in, then find first in toc
        this.rootnode = { nodes: this.state.item_toc };
        util.setParents(this.rootnode);
        this._setSelected(this.rootnode, this.kbrid);
        /*
                if(this.selectedNode){
                    util.setOpened(this.selectedNode);
                }
                */
      }
      if (this.state.toc_open) {
        this.leftSideWidthPerc = this.state.global_screen_specs.tocWidthPercent;
        this.rightSideWidthPerc =
          this.state.global_screen_specs.topicWidthPercent;
      } else {
        this.leftSideWidthPerc = 0;
        this.rightSideWidthPerc = 100;
      }
      this.myRender();
    }
  }

  _setSelected(node, href) {
    node.selected = false;
    if (node.href == href) {
      node.selected = true;
      this.selectedNode = node;
      util.setOpened(this.selectedNode);
      storeInstance.dispatch("setState", {
        property: "selected_tocitem",
        value: node,
      });
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this._setSelected(node.nodes[i], href);
      }
    }
  }

  _recurseToHREF(node) {
    if (node.href) {
      return node.href;
    }
    for (var i = 0; i < node.nodes; i++) {
      return this._recurseToHREF(node.nodes[i]);
    }
  }

  _handleTocItemClicked(e) {
    var node = e.detail;
    if (this._isCurrentItem(node.href)) {
      history.pushState(
        null,
        null,
        "/kb/" +
          this.state.langCode +
          "/" +
          this.state.item.item.externalId +
          node.href
      );
      this.kbrid = node.href;
      this._setSelected(this.rootnode, this.kbrid);
    } else {
      /*hmmm might need to deduce ITEM TYPE from the node.href */
      Router.go(
        "/kb/" +
          this.state.langCode +
          "/" +
          this.state.item.item.externalId +
          node.href
      );
    }
  }

  _handleTocTopicLinkClicked(e) {
    if (this._isCurrentItem(e.detail)) {
      history.pushState(
        null,
        null,
        "/kb/" +
          this.state.langCode +
          "/" +
          this.state.item.item.externalId +
          e.detail
      );
      this.kbrid = e.detail;
      this._setSelected(this.rootnode, this.kbrid);
      storeInstance.dispatch("touch");
    }
  }

  _isCurrentItem(href) {
    var aTmp = href.split("_");
    if (aTmp.length > 0) {
      if (aTmp[1] == this.state.item.item.externalId) {
        return true;
      }
    }
    return false;
  }

  myRender() {
    render(this.helpsetTemplate(), this.shadowRoot);
    if (!this.helpsetcontainer) {
      this.helpsetcontainer =
        this.shadowRoot.querySelector("#helpsetcontainer");
      this.helpsetcontainer.addEventListener(
        "splitter-dragend",
        this.updateScreenWidthSpecs.bind(this)
      );
    } else {
      if (!this.state.toc_open) {
        var leftPx = 0;
        var rightPx = this.state.global_screen_specs.viewportWidth;
      } else {
        var leftPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.leftSideWidthPerc
        );
        var rightPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.rightSideWidthPerc
        );
      }
      this.helpsetcontainer.children[0].style.flex = "1 1 " + leftPx + "px";
      this.helpsetcontainer.children[1].style.flex = "1 1 " + rightPx + "px";
    }
  }

  updateScreenWidthSpecs(e) {
    storeInstance.dispatch("setHelpsetLayoutWidths", {
      left: e.currentTarget.children[0].offsetWidth,
      right: e.currentTarget.children[1].offsetWidth,
    });
    storeInstance.dispatch("setState", {
      property: "toc_open",
      value: e.currentTarget.children[0].offsetWidth > 0,
    });
  }

  helpsetTemplate() {
    return html`
      <style>
            #leftside{
                height: ${this.state.global_screen_specs.workspaceHeight}px;
                overflow: auto;
                width: ${this.leftSideWidthPerc}%;
            }
            #rightside{
                height: ${this.state.global_screen_specs.workspaceHeight}px;
                overflow: auto;
                width: ${this.rightSideWidthPerc}%;

            }
            #pagewrapper{
                max-width:1024px;
                padding: 1rem 2rem;
            }
            #topicwrapper{
                background-color: var(--kb-surface-color);
                border: 1px solid black;
                padding: 1rem 2rem;
                margin-top: var(--block-padding);
                border: var(--kb-surface-border);
                border-radius: var(--kb-border-radius);
            }

            #search{
                margin: .5rem 1.5rem .5rem 1.5rem;
            }
            #searchbtn{
                padding-left:1rem;
                cursor:pointer;
            }

        </div>
      </style>
      <vaadin-split-layout id="helpsetcontainer">
        <div id="leftside">
          <div id="search">
            <ui5-input
              id="searchbox"
              @keyup="${this.checkEnterKey.bind(this)}"
              placeholder="${this.string["_helpsetsearch"]}"
              value="${this.state.searchterm ? this.state.searchterm : ""}"
            ></ui5-input>
            <iron-icon
              id="searchbtn"
              icon="vaadin:search"
              @click="${this._search.bind(this)}"
            ></iron-icon>
          </div>
          <kb-toc .rootnode="${this.rootnode}" .kbrid="${this.kbrid}"></kb-toc>
        </div>
        <div id="rightside">
          <div id="pagewrapper">
            <kb-searchview></kb-searchview>
          </div>
        </div>
      </vaadin-split-layout>
    `;
  }

  checkEnterKey(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      this._search();
    }
  }
  _search() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    history.pushState(
      null,
      null,
      "/kb/" +
        this.state.langCode +
        "/kbsearch/" +
        searchbox.value +
        "/" +
        this.state.item.item.externalId
    );
    Router.go(
      "/kb/" +
        this.state.langCode +
        "/kbsearch/" +
        searchbox.value +
        "/" +
        this.state.item.item.externalId
    );
  }
}

customElements.define("kb-helpset-search", KbHelpsetSearch);
